import { BaseText } from '@/shared/components/StyledText';
import { green } from '@/shared/styles/colors';
import styled from '@emotion/native';

export const Title = styled(BaseText)({
  marginBottom: 14,
  textAlign: 'left',
  fontSize: 14,
  color: green,
});
